import React from "react";
import { PAGE_SIZE, ORIENTATION } from "./constants/appConstants";
import { parseSync } from 'svgson';
import { updateSvgValues } from "./svgUtils";
import { message } from 'antd';
import { CONTEXT_KEYS } from '../context/complexArtboardContext';
import { CREATIVE_BLOCK, DYNAMIC_TABLE_BLOCK, FOOTER, HEADER, PrintingModal, TABLE_OF_CONTENTS } from "./complexDocumentConstants";
import { COMPLEX_PAGE_OPTIONS } from '../containers/ComplexDocumentDesign/translationValues';
import { Quill } from "react-quill";
import { DOCUMENT_PANEL, STATUS_MONITORING } from "../containers/Dashboard/StatusMonitoring/TranslationValues";
import { DeniedSVGIcon, HourGlassIcon, TickSVG } from "../images/svgIcons";
import { IconWrapper } from "../containers/Dashboard/StatusMonitoring/Styles";
import moment from 'moment';
import { emailFunnelChartLabels, metaSearchKeyMappings } from "./constants/statusMonitoring";
import { deepCopy } from "./javascript";
import { COMPLEX_DOCUMENT_CONTEXT_KEYS } from "../context/complexDocumentContext";
import { checkCommunName, getTocFlow } from "./services/complexDocumentsAPI";
import { EMAIL_DASHBOARD } from "../containers/Dashboard/TranslationValues";

export const Clipboard = Quill.import('modules/clipboard');
const WEBSOCKET_URL = process.env.REACT_APP_SERVER_URL.replaceAll('http://', 'ws://').replaceAll('https://', 'wss://');
export default {
  BASE_URL: `${process.env.REACT_APP_SERVER_URL+process.env.REACT_APP_BACKEND+'/'}`,
  DESIGN_SYSTEM_URL: `${process.env.REACT_APP_SERVER_URL+process.env.REACT_APP_DESIGN_SYSTEM+'/'}`,
  TRANSACTION_SYSTEM_URL: `${process.env.REACT_APP_SERVER_URL+process.env.REACT_APP_TRANSACTIONS_SYSTEM+'/'}`,
  BATCH_SYSTEM_URL: `${process.env.REACT_APP_SERVER_URL+process.env.REACT_APP_BATCH_SYSTEM+'/'}`,
  // BATCH_SYSTEM_URL: `${process.env.REACT_APP_SERVER_URL+'/batch/'}`,
  TRACKING_SYSTEM_URL: `${process.env.REACT_APP_SERVER_URL+process.env.REACT_APP_TRACKING_SYSTEM+'/'}`,
  // TRACKING_SYSTEM_URL: `${process.env.REACT_APP_SERVER_URL+'/tracking/'}`,
  DOWNLOAD_URL: `${process.env.REACT_APP_SERVER_URL+process.env.REACT_APP_BACKEND+'/generatedpdf/'}`,
  EML_DOWNLOAD_URL: `${process.env.REACT_APP_SERVER_URL+process.env.REACT_APP_BACKEND+'/'}`,
  AUTH_BASE_URL: `${process.env.REACT_APP_SERVER_URL || ''}`,
  AUTH_BASE_PATH: `${process.env.REACT_APP_AUTH || ''}`,
  AUTH_SERVICE_URL: `${process.env.REACT_APP_SERVER_URL+process.env.REACT_APP_AUTH+'/'}`,
  SSO_SERVICE_URL: `${process.env.REACT_APP_SERVER_URL+process.env.REACT_APP_BACKEND+'/sso/'}`,
  GOOGLE_FONTS: `https://www.googleapis.com/webfonts/v1/webfonts?key=${process.env.REACT_APP_GOOGLE_FONTS_TOKEN}`,
  IMAGE_GENERATOR_URL: `${process.env.REACT_APP_IMAGE_GENERATOR_URL}`,
  DEPLOYMENT_URL: `${process.env.REACT_APP_FRONTEND}`,
  SERVER_URL: process.env.REACT_APP_SERVER_URL,
  APOLLO_HTTP_URL: `${process.env.REACT_APP_SERVER_URL+process.env.REACT_APP_TRACKING_SYSTEM+'/graphiql?path=/tracking/graphql&wsPath=/tracking/graphql'}`,
  APOLLO_SOCKET_URL: `${WEBSOCKET_URL+process.env.REACT_APP_TRACKING_SYSTEM+'/graphql'}`,
  // KUBE_URL:`https://kubedev03.tekclansolutions.com:3443`
  // SUPERTOKENS_BASE_URL: `${process.env.SUPERTOKENS_URL}`
  FRONTEND_URL: process.env.REACT_APP_SERVER_URL,
  EMBED_AUTHENTICATE_URL: `${process.env.REACT_APP_SERVER_URL + '/pds/client'}`
};

export const SUPPORT_EMAIL_ID = 'support@perfectdoc.studio';

export const ENABLE_INSPIRATIONS = false;
export const OPENREPLAY_DISABLE_SECURE_MODE = process.env.REACT_APP_OPENREPLAY_SECURE_MODE === 'true';
export const ENTERPRISE_ENV = process.env.REACT_APP_DEPLOYMENT_TYPE === 'enterprise';
// export const AZURE_DEPLOYMENT = process.env.REACT_APP_DEPLOYMENT_ENV === 'azure';
export const AZURE_DEPLOYMENT = true; // After supertokens was replaced by backend, this is the current default setting
export const ENABLE_EMAIL_DESIGNS = ENTERPRISE_ENV || process.env.REACT_APP_ENABLE_EMAIL_REVAMP === 'true'; // temporarily disabled the email design system in the SaaS environment
console.log("process.env.REACT_APP_ENABLE_EMAIL_REVAMP :: ", process.env.REACT_APP_ENABLE_EMAIL_REVAMP);
export const EMAIL_REVAMP = process.env.REACT_APP_ENABLE_EMAIL_REVAMP === 'true';
export const DEFAULT_DATE_TIME_FORMAT = 'YYYY-MM-DD HH:mm:ss';
export const READABLE_DATE_TIME_FORMAT = 'lll';
export const ENABLE_TOLGEE = process.env.REACT_APP_TOLGEE_ENABLE === 'true';
export const PDF_DOWNLOAD_PRICE_USD = 1;
export const APP_VERSION = process.env.REACT_APP_VERSION;
export const SSO_REDIRECT_URL = `${process.env.REACT_APP_SERVER_URL}/redirect`;
// export const SSO_REDIRECT_URL = 'http://localhost:7000/redirect';

export const TERMS_AND_CONDITIONS_URL = 'https://perfectdoc.studio/policies.html';

const LANGUAGE_MAPPING = {
  'en': 'Open Sans',
  'en-GB': 'Open Sans',
  'en-US': 'Open Sans',
  'es-US': 'Open Sans',
  'fr': 'Open Sans',
  'pt': 'Open Sans',
  'ja': 'Noto Sans JP',
  'ar': 'Noto Sans Arabic'
}

export const DEFAULT_FONT_FOR_LOCALISED_LANGUAGES = (lang) => {
  return LANGUAGE_MAPPING[lang] || 'Open Sans';
}

export const PASSWORD_MAX_LENGTH = 30;
export const EMAIL_MAX_LENGTH = 100;

export const getWidthHeightScale = ({value, orientation, size, dimension, isDndFlow, isDocToMail, isPreviewModal, isActModal, actualScaling, scaling, rulerWidthAdjuster}) => {
  const reduceScaleValue =
    dimension === 'width'
      ? orientation === ORIENTATION.LANDSCAPE
        ? PAGE_SIZE.US_LEGAL_LANDSCAPE_WIDTH
        : PAGE_SIZE.US_LEGAL_LANDSCAPE_HEIGHT
      : dimension === 'height' && orientation === ORIENTATION.LANDSCAPE
      ? PAGE_SIZE.US_LEGAL_LANDSCAPE_HEIGHT
      : PAGE_SIZE.US_LEGAL_LANDSCAPE_WIDTH;

  let element;
  let usLandscape;
  let a4Landscape;
  
  if(isDndFlow || isDocToMail) {
    element = document.getElementsByClassName('showSideBar')[0];
    usLandscape =0.2;
    a4Landscape = 0.25;
  }
  if(isPreviewModal) {
    element = document.getElementsByClassName('previewModalView')[0];
    usLandscape = 0.5;
    a4Landscape = 0.55
  }
  if(isActModal){
    element = document.getElementsByClassName('actModalView')[0];
    usLandscape = 0.8;
    a4Landscape = 0.85;
  }

  if (isDndFlow || isDocToMail || isPreviewModal) {
    if (size !== PAGE_SIZE.CUSTOM) {
      actualScaling = orientation === ORIENTATION.LANDSCAPE ? ((size === PAGE_SIZE.US_LEGAL || size === PAGE_SIZE.US_LETTER) ? usLandscape : a4Landscape) : scaling;
    } else if (size === PAGE_SIZE.CUSTOM && value > reduceScaleValue) {
      if(dimension === 'width'){
      actualScaling = (isDndFlow||isDocToMail) ? Math.floor(((element.offsetWidth) / value )*100)/100 : isPreviewModal? Math.floor((element.offsetWidth / value )*10)/10 : scaling
      } else {
        return {updatedScaling: actualScaling, widthHeightValue:`${actualScaling * value + rulerWidthAdjuster}px` }
      }
    } else {
      actualScaling = size === PAGE_SIZE.CUSTOM ? (orientation === ORIENTATION.LANDSCAPE ? a4Landscape : usLandscape) : scaling;
    }
  }
  
  return {updatedScaling: actualScaling, widthHeightValue:`${actualScaling * value + rulerWidthAdjuster}px` }
};

const getBlockdtoListFromDocumentContext = (blockDetails, documentContext) => {
  if (blockDetails?.blockDTOList) {
    return blockDetails.blockDTOList;
  }
  if (!documentContext) {
    return [];
  }
  const block = documentContext[blockDetails.uuid];
  const tableProperties = block.style.tableProperties;
  const childBlocks = [];
  if (tableProperties.topBlock) {
    childBlocks.push(documentContext[tableProperties.topBlock]);
  }
  if (tableProperties.bottomBlock) {
    childBlocks.push(documentContext[tableProperties.bottomBlock]);
  }
  return childBlocks;
};

export const autoTransform = (
  blocks,
  existingFlow = { width: 794, height: 1123, fontSize: 16 },
  width = 794,
  height = 1123,
  isCreateEmailFromDocument = false,
  documentContext
) => {
  const widthScalingFactor = existingFlow.width / width;
  const heightScalingFactor = existingFlow.height / height;
  const widthLessThanHeight = widthScalingFactor < heightScalingFactor;
  const fontScalingFactor = widthLessThanHeight
    ? Math.min(widthScalingFactor, heightScalingFactor)
    : Math.max(widthScalingFactor, heightScalingFactor);
  for (let i = 0; i < blocks.length; i++) {
    const singleBlock = blocks[i];
    if (singleBlock.blockType === 'creative' || singleBlock.blockType === DYNAMIC_TABLE_BLOCK) {
      const block_dto =
        singleBlock.blockType === DYNAMIC_TABLE_BLOCK ? getBlockdtoListFromDocumentContext(singleBlock, documentContext) : [singleBlock];
      for (let j = 0; j < block_dto.length; j++) {
        const block = block_dto[j];
        if (block.style) {
          if (block.style.height) {
            const creativeBlockHeight = Math.round(block.style.height * widthScalingFactor);
            block.style.height = creativeBlockHeight;
          }
          if (block.style.fontSize) {
            block.style.fontSize = Math.round(block.style.fontSize * fontScalingFactor);
          }
        }
        if (block.contents) {
          block.contents.forEach(async content => {
            if (content.style && content.style.width) {
              content.style.width = Math.round(content.style.width * widthScalingFactor);
            }
            if (content.style && content.style.height) {
              content.style.height = Math.round(content.style.height * widthScalingFactor);
            }

            if (content.style && content.style.x) {
              content.style.x = Math.round(content.style.x * widthScalingFactor);
            }
            if (content.style && content.style.y) {
              content.style.y = Math.round(content.style.y * widthScalingFactor);
            }

            if (content.contents && content.contentType !== 'chart') {
              content.contents.forEach(innerContent => {
                if (innerContent.style) {
                  if (innerContent.style.fontSize) {
                    innerContent.style.fontSize = Math.round(
                      innerContent.style.fontSize * fontScalingFactor,
                    );
                  } else if (isCreateEmailFromDocument && !innerContent.style.fontSize) {
                    innerContent.style.fontSize = Math.round(
                      existingFlow.fontSize * fontScalingFactor,
                    );
                  }
                }
              });
            }

            if (content.contentType === 'svg') {
              const parsedJSON = parseSync(content.url);
              const updatedSVGDetails = {
                width: content.style.width,
                height: content.style.height,
                x: content.style.x,
                y: content.style.y,
                rotate: content.style.rotate,
                svgElement: true,
              };
              const { stringSVG } = updateSvgValues(
                updatedSVGDetails,
                {
                  elementDetails: {
                    style: {},
                    value: {
                      ...parsedJSON,
                      url: '',
                    },
                    uiType: content.uiType,
                  },
                },
                'style',
              );
              content.url = stringSVG;
            }
          });
        }
      }
    }
  }
  return { isTransformed: true, updatedBlocks: blocks };
};

export const block_Selection = ({
  selectedBlocks,
  itemUUID,
  parentUUID,
  flowDetails,
  selectedBlocksParent,
  isHeaderOrFooterSelected,
  isContentSelected,
  updateArtboard,
  methods,
  t
}) => {
  const selectedBlock = flowDetails[`${parentUUID}-0`].indexOf(itemUUID);
  const firstBlockIndex = selectedBlocks[0]
    ? flowDetails[`${parentUUID}-0`].indexOf(selectedBlocks[0])
    : 0;
  const lastBlockIndex = selectedBlocks[selectedBlocks.length - 1]
    ? flowDetails[`${parentUUID}-0`].indexOf(selectedBlocks[selectedBlocks.length - 1])
    : 0;
  const selectedBlockIsHeaderOrFooter =
    flowDetails.header === itemUUID || flowDetails.footer === itemUUID;
  const selectedBlockIsContent = flowDetails[`${parentUUID}-0`].includes(itemUUID);
  if (!selectedBlocksParent || selectedBlocksParent === parentUUID) {
    if (selectedBlocks.includes(itemUUID)) {
      const removeBlockIndex = selectedBlocks.indexOf(itemUUID);
      if (removeBlockIndex === 0 || removeBlockIndex === selectedBlocks.length - 1) {
        selectedBlocks = selectedBlocks.filter(item => item !== itemUUID);
      } else {
        message.warning(t(COMPLEX_PAGE_OPTIONS.BLOCK_UNSELECT_WARNING.key, COMPLEX_PAGE_OPTIONS.BLOCK_UNSELECT_WARNING.value));
        return;
      }

      if (isHeaderOrFooterSelected && selectedBlockIsHeaderOrFooter) {
        isHeaderOrFooterSelected = false;
      }
      if (isContentSelected && selectedBlockIsContent) {
        isContentSelected = false;
      }
    } else {
      if (
        (isHeaderOrFooterSelected && selectedBlockIsContent) ||
        (isHeaderOrFooterSelected && selectedBlockIsHeaderOrFooter)
      ) {
        message.warning(t(COMPLEX_PAGE_OPTIONS.HEADER_FOOTER_SELECTED_WARNING.key, COMPLEX_PAGE_OPTIONS.HEADER_FOOTER_SELECTED_WARNING.value, { blockType: flowDetails.header === selectedBlocks[0] ? 'Header' : 'Footer' }));
        return;
      }
      if (isContentSelected && selectedBlockIsHeaderOrFooter) {
        message.warning(t(COMPLEX_PAGE_OPTIONS.CONTENT_SELECTED_WARNING.key, COMPLEX_PAGE_OPTIONS.CONTENT_SELECTED_WARNING.value));
        return;
      }

      if (
        firstBlockIndex - 1 === selectedBlock ||
        lastBlockIndex + 1 === selectedBlock ||
        selectedBlocks.length === 0
      ) {
        const _block = methods.get()[itemUUID];
        if ((_block.type === HEADER || _block.type === FOOTER) && _block.isStandalone) {
          updateArtboard({[CONTEXT_KEYS.STANDALONE_BLOCK_EDIT]: _block.uuid});
          // message.warning(t(COMPLEX_PAGE_OPTIONS.HEADER_FOOTER_REFERENCED_WARNING.key, COMPLEX_PAGE_OPTIONS.HEADER_FOOTER_REFERENCED_WARNING.value, { blockType: _block.type}));
          return;
        }
        if (_block.type === HEADER || _block.type === FOOTER) {
          isHeaderOrFooterSelected = true;
        } else {
          isContentSelected = true;
        }
        selectedBlocks =
          firstBlockIndex - 1 === selectedBlock
            ? [itemUUID, ...selectedBlocks]
            : lastBlockIndex + 1 === selectedBlock
            ? [...selectedBlocks, itemUUID]
            : [...selectedBlocks, itemUUID];
      } else {
        message.warning(t(COMPLEX_PAGE_OPTIONS.BLOCK_SELECTION_SEQUENCE_WARNING.key, COMPLEX_PAGE_OPTIONS.BLOCK_SELECTION_SEQUENCE_WARNING.value));
        return;
      }
    }

    updateArtboard({
      [CONTEXT_KEYS.HEADER_OR_FOOTER_BLOCK_SELECTED]: isHeaderOrFooterSelected,
      [CONTEXT_KEYS.CONTENT_BLOCK_SELECTED]: isContentSelected,
      [CONTEXT_KEYS.SELECTED_BLOCKS]: selectedBlocks,
      [CONTEXT_KEYS.SELECTED_BLOCKS_PARENT]: selectedBlocks.length > 0 ? parentUUID : '',
    });
  }
};

export const checkSessionUserAccess = (userDetails, userType, roles) => {
  if (roles) {
    return (
      userDetails?.userType === userType && userDetails.roles.some(role => roles.includes(role))
    );
  } else {
    return userDetails?.userType === userType;
  }
};

export const checkUserAccessRoles = (userDetails, roles) => {
  return userDetails?.roles?.some(role => roles.includes(role));
};

export const getClipboardData = async () => {
  let copiedElements;
  try {
    const elements = await navigator.clipboard.readText();
    copiedElements = JSON.parse(elements);
  } catch (err) {
    console.error('Failed to read clipboard contents: ', err);
    copiedElements = { pdsCopiedElements: [] }; // Set to null or some default value in case of an error
  }
  return copiedElements;
};

export const resetClipboardData = async () => {
  try {
    await navigator.clipboard.writeText('');
  } catch (err) {
    console.error('Failed to clear clipboard contents: ', err);
  }
};

export const EXISTING_CHANNELS = ENTERPRISE_ENV ? [
   {
     key: 'document',
     translateKey: 'DOCUMENT'
   },
   {
     key: 'email',
     translateKey: 'EMAIL'
   },
   {
     key: 'short_message',
     translateKey: 'SHORT_MESSAGE'
   }
 ] : [
   {
     key: 'document',
     translateKey: 'DOCUMENT'
   },
   {
     key: 'email',
     translateKey: 'EMAIL'
   },
 ];

 export const getTemplateVersion = version => {
   return version === 0 ? 'published' : version === 1 ? 'testing' : 'draft';
 };

 const statusLabelMap = {
   success: 'SUCCESS',
   sent: 'SENT',
   bounced:'BOUNCED',
   delivered: 'DELIVERED',
   opened: 'OPENED',
   clicked : 'CLICKED',
   failure: 'FAILURE',
   inprogress: 'IN_PROGRESS',
   in_progress: 'IN_PROGRESS',
   yet_to_start: 'YET_TO_START',
   processing_complete: 'PROCESSING_COMPLETE',
   waiting_for_approval_level_1: 'WAITING_FOR_APPROVAL_LEVEL_1',
   approved_by_level_1: 'APPROVED_BY_LEVEL_1',
   waiting_for_approval_level_2: 'WAITING_FOR_APPROVAL_LEVEL_2',
   approved_by_level_2: 'APPROVED_BY_LEVEL_2',
   waiting_for_approval_level_3: 'WAITING_FOR_APPROVAL_LEVEL_3',
   approved_by_level_3: 'APPROVED_BY_LEVEL_3',
   waiting_for_approval_level_4: 'WAITING_FOR_APPROVAL_LEVEL_4',
   approved_by_level_4: 'APPROVED_BY_LEVEL_4',
   ready_to_print: 'READY_TO_PRINT_FILTER',
   sent_for_printing: 'PRINT_INITIATED_FILTER',
   printing_complete: 'PRINTING_COMPLETE',
   reject_by_level_1: 'REJECT_BY_LEVEL_1',
   reject_by_level_2: 'REJECT_BY_LEVEL_2',
   reject_by_level_3: 'REJECT_BY_LEVEL_3',
   reject_by_level_4: 'REJECT_BY_LEVEL_4',
   no_approver_found: 'NO_APPROVER_FOUND_FILTER',
   yet_to_print: 'YET_TO_PRINT',
   print_in_queue: 'PRINT_IN_QUEUE',
   print_completed: 'PRINT_COMPLETED',
 };

 const statusColorMap = {
   in_progress: '#3FB8D5',
   yet_to_start: '#C9C8CC',
   processing_complete: '#C8E066',
   success: '#C8E066',
   bounced: '#3FB8D5',
   sent: '#C8E066',
   delivered: '#99B3F0',
   opened: '#D6E1FA',
   clicked : '#1B3074',
   ready_to_print: '#AC9BFB',
   sent_for_printing: '#FF4560',
   failure: '#35346A',
   printing_complete: '#FCE83A',
   inprogress: '#6CE5E8',
   waiting_for_approval_level_1: '#232360',
   waiting_for_approval_level_2: '#232360',
   waiting_for_approval_level_3: '#232360',
   waiting_for_approval_level_4: '#232360',
   approved_by_level_1: '#AC9BFB',
   approved_by_level_2: '#AC9BFB',
   approved_by_level_3: '#AC9BFB',
   approved_by_level_4: '#AC9BFB',
   reject_by_level_1: '#D72D6C',
   reject_by_level_2: '#D72D6C',
   reject_by_level_3: '#D72D6C',
   reject_by_level_4: '#D72D6C',
   no_approver_found: '#6F08EE',
   yet_to_print: '#232360',
   print_in_queue: '#6CE5E8',
   print_completed: '#C8E066',
 };

 export const doesBatchHaveDocuments = (batchDetails) => {
   return batchDetails.batchStats.filter(batch => batch.channel === 'print').length > 0;
 }

 export const getStatusMessage = (status, t) => {
   // Check if status exists in the map
   if (statusLabelMap[status]) {
     const key = statusLabelMap[status];
     return t(STATUS_MONITORING[key].key, STATUS_MONITORING[key].value);
   }
   return '';
 };

 export const getStatusColor = status => {
   if (statusColorMap[status]) {
     return statusColorMap[status];
   }
   return '';
 };

 export const getStatusIcon = caseStatus => {
   switch (caseStatus) {
     case 'in_progress':
       return (
         <IconWrapper background={'#a123a3'}>
           <HourGlassIcon />
         </IconWrapper>
       );
     case 'yet_to_start':
       return (
         <IconWrapper background={'#a123a3'}>
           <HourGlassIcon />
         </IconWrapper>
       );
     case 'processing_complete':
       return (
         <IconWrapper background={'#c8e066'}>
           <TickSVG />
         </IconWrapper>
       );
     case 'waiting_for_approval_level_1':
     case 'waiting_for_approval_level_2':
     case 'waiting_for_approval_level_3':
     case 'waiting_for_approval_level_4':
       return (
         <IconWrapper background={'#a123a3'}>
           <HourGlassIcon />
         </IconWrapper>
       );
     case 'approved_by_level_1':
     case 'approved_by_level_2':
     case 'approved_by_level_3':
     case 'approved_by_level_4':
       return (
         <IconWrapper background={'#c8e066'}>
           <TickSVG />
         </IconWrapper>
       );
      case 'ready_to_print':
        return (
          <IconWrapper background={'#c8e066'}>
            <TickSVG />
          </IconWrapper>
        );
     case 'sent_for_printing':
       return (
         <IconWrapper background={'#a123a3'}>
           <HourGlassIcon />
         </IconWrapper>
       );
     case 'printing_complete':
       return (
         <IconWrapper background={'#c8e066'}>
           <TickSVG />
         </IconWrapper>
       ); // Printer
     case 'reject_by_level_1':
     case 'reject_by_level_2':
     case 'reject_by_level_3':
     case 'reject_by_level_4':
       return (
           <DeniedSVGIcon />
       );
     default:
       return (
        <IconWrapper background={'#a123a3'}>
          <HourGlassIcon />
        </IconWrapper>
       );
   }
 };

 export const isShortMessageEnabled = false;

 export const getChannelTotals = (data, localize, t, processedCount = false) => {
   const totals = data.reduce(
     (acc, item) => {
       const count = processedCount
         ? Number(item.successCount || 0) + Number(item.failureCount || 0)
         : Number(item.totalCount || 0);
       acc[item.channel] = (acc[item.channel] || 0) + count;
       return acc;
     },
     { print: 0, email: 0, ...( isShortMessageEnabled && { message: 0 }) }
   );

   if (localize) {
     const localizedKeys = {
       print: t(STATUS_MONITORING.CHART_PRINT_LABEL.key, STATUS_MONITORING.CHART_PRINT_LABEL.value),
       email: t(STATUS_MONITORING.CHART_EMAIL_LABEL.key, STATUS_MONITORING.CHART_EMAIL_LABEL.value),
       sms: t(STATUS_MONITORING.CHART_SMS_LABEL.key, STATUS_MONITORING.CHART_SMS_LABEL.value),
       message : t(
        STATUS_MONITORING.CHART_MESSAGES_LABEL.key,
        STATUS_MONITORING.CHART_MESSAGES_LABEL.value,
      ),
       voice: t(STATUS_MONITORING.CHART_VOICE_LABEL.key, STATUS_MONITORING.CHART_VOICE_LABEL.value),
       whatsapp: t(
         STATUS_MONITORING.CHART_WHATSAPP_LABEL.key,
         STATUS_MONITORING.CHART_WHATSAPP_LABEL.value,
       ),
     };

     return Object.entries(totals).reduce((localizedTotals, [key, value]) => {
       const localizedKey = removeInvisibleCharacters(localizedKeys[key]);
       if (localizedKey) {
         localizedTotals[localizedKey] = value;
       }
       return localizedTotals;
     }, {});
   }

   return totals;
 };

 export const getProgressPercentage = (total, data) => {
   if (total && data) {
     const totalProcessed = data.reduce(
       (acc, batch) => acc + Number(batch?.successCount || 0) + Number(batch?.failureCount || 0) + Number(batch?.unknownCount || 0),
       0,
     );
     const percentage = Math.round((totalProcessed / total) * 100);
     return percentage;
   }
   return 0;
 };

 export const isEmptyObject = obj => {
   return Object.keys(obj || {}).length === 0;
 };

export const aggregatedData = data => {
  const aggregatedData = data.reduce((acc, item) => {
    const batchNumber = item.batchNumber;

    if (!acc[batchNumber]) {
      acc[batchNumber] = {
        batchNumber,
        inQueueCount: 0,
        successCount: 0,
        failureCount: 0,
        totalCount: 0,
      };
    }

    acc[batchNumber].inQueueCount += Number(item.inQueueCount);
    acc[batchNumber].successCount += Number(item.successCount);
    acc[batchNumber].failureCount += Number(item.failureCount);
    acc[batchNumber].totalCount += Number(item.totalCount);
    acc[batchNumber].createdOn = moment(item.createdOn).format('D, MMMM  YYYY');
    acc[batchNumber].createdOnTime = moment(item.createdOn).format('LT');
    return acc;
  }, {});

  return Object.values(aggregatedData);
};

export const aggregateBatchStats = (data, activeChannel) => {
  const channel = activeChannel === 'Documents' ? 'print' : activeChannel.toLowerCase()
  return data.reduce(
    (totals, batch) => {
      if (batch.channel === channel) {
        totals.inQueueCount += Number(batch.inQueueCount);
        totals.successCount += Number(batch.successCount);
        totals.failureCount += Number(batch.failureCount);
        totals.totalCount += Number(batch.totalCount);
      }
      return totals;
    },
    { successCount: 0, inQueueCount: 0, failureCount: 0, totalCount: 0 }
  );
};

export const transformMetaSearchFilter = (inputArray, metaKeyRefs, metaValueRefs) => {
  const keyValueMap = inputArray.reduce((acc, obj) => {
    let key = obj.key;
    let value = obj.value;
    const valueDataSet = metaValueRefs[key];
    if (!valueDataSet) {
      acc[key] = acc[key] ? `${acc[key]},${value}` : value;
      return acc;
    }
    const valueSet = valueDataSet.find(val => val.key.toLowerCase() === obj.value.toLowerCase());
    acc[key] = acc[key] ? `${acc[key]},${valueSet.value}` : valueSet.value;
    return acc;
  }, {});

  return Object.entries(keyValueMap).map(([key, value]) => ({
    fieldName: metaKeyRefs[key],
    value,
  }));
};

export const transformRemovedTagFilters = (exclusionAudit, metaValueRefs, usersList = [], t) => {
  const defaultKeys = new Set(['channel', 'uniq_name', 'uniq_id', 'language', 'status']);
  const exclusionAuditData = deepCopy(exclusionAudit);

  // Map user IDs to display names for quick lookup
  const userMap = Object.fromEntries(usersList.map(({ id, displayName }) => [id, displayName]));

  const mapExclusionKeys = (exclusions) =>
    exclusions.flatMap(({ fieldName, value }) => {
      const key = defaultKeys.has(fieldName)
        ? metaSearchKeyMappings(t)[fieldName.replace(/\./g, '_')]
        : fieldName.replace(/\./g, ' ').replace(/\b\w/g, (char) => char.toUpperCase()); // Capitalize first letter of each word

      return value.split(',').map((val) => {
        const trimmedVal = val.trim();
        const valueDataSet = metaValueRefs[key]?.find((data) => data.value === trimmedVal);
        return { key, value: valueDataSet ? valueDataSet.key : trimmedVal };
      });
    });

  // Map exclusion IDs to their index for quick reference
  const exclusionIndexMap = Object.fromEntries(exclusionAudit.map(({ id }, index) => [id, index]));

  exclusionAuditData.forEach((audit) => {
    audit.doneBy = userMap[audit.doneBy] || ''; // Assign user display name

    if (audit.type === 'removed') {
      audit.exclusion = mapExclusionKeys(audit.exclusion);
      audit.isRemovedIncluded = false;
    } else if (audit.type === 'included' && audit.reference) {
      const refIndex = exclusionIndexMap[audit.reference];
      if (refIndex !== undefined) {
        audit.exclusion = mapExclusionKeys(exclusionAudit[refIndex].exclusion);
        audit.isRemovedIncluded = true;
        exclusionAuditData[refIndex].isRemovedIncluded = true;
      }
    }
  });

  return exclusionAuditData;
};

export const transformMetaSearchKeys = (searchKeys, t) => {
  const defaultKeys = ['channel', 'uniq name', 'uniq id', 'language', 'status'];
  const transformedKeys = searchKeys.map(key => {
    const mutatedKey = key.replace(/[_\.]/g, ' ');
    return defaultKeys.includes(mutatedKey)
      ? metaSearchKeyMappings(t)[mutatedKey.replace(/ /g, '_')]
      : mutatedKey;
  });

  const referenceKeysObject = transformedKeys.reduce((acc, transformedName, index) => {
    acc[transformedName] = searchKeys[index];
    return acc;
  }, {});
  return { transformedKeys, referenceKeysObject };
};

export const transformExclusionAndSearchKey = (data = [], type, t) => {
  return type === 'exclusions'
    ? data.map(group =>
        group.flatMap(({ fieldName, value }) =>
          (value.includes(',') ? value.split(',') : [value]).map(val => ({
            fieldName: metaSearchKeyMappings(t)[fieldName] || fieldName.replace(/[_\.]/g, ' '),
            value: val.trim(),
          })),
        ),
      )
    : type === 'search'
    ? data.flatMap(({ fieldName, value }) =>
        (value.includes(',') ? value.split(',') : [value]).map(val => ({
          fieldName: metaSearchKeyMappings(t)[fieldName] || fieldName.replace(/[_\.]/g, ' '),
          value: val.trim(),
        })),
      )
    : [];
};

export const removeInvisibleCharacters = (str) =>  str.replace(/[\u200B-\u200D\uFEFF]/g, '');

export const formatDataForApexBarChart = (data, t, languageList, contentType) => {
  if(!data.length && !languageList.length) return {barChartData:[], categories: []};
  const categories = data.map(entry => {
    const lang = languageList.find(lang => lang.value === entry.lang);
    return lang ? lang.key : '' ;
});
  const successSeries = data.map(entry => entry.success||0);
  const failureSeries = data.map(entry => entry.failure||0);

  return {
    barChartData: [
      {
          name: removeInvisibleCharacters(t(DOCUMENT_PANEL.SUCCESS_CHART_LABEL.key, DOCUMENT_PANEL.SUCCESS_CHART_LABEL.value)),
          data: successSeries,
      },
      {
          name: removeInvisibleCharacters(t(DOCUMENT_PANEL.FAILURE_CHART_LABEL.key, DOCUMENT_PANEL.FAILURE_CHART_LABEL.value)),
          data: contentType === PrintingModal ? [0] : failureSeries,
      },
    ],
      categories: categories
  };
}

export const mergeFields = data => {
  if (data.length === 0) {
    return [];
  }
  const result = data.reduce((acc, item) => {
    let existing = acc.find(obj => obj.fieldName === item.fieldName);
    if (existing) {
      existing.value += `,${item.value}`;
    } else {
      acc.push({ ...item });
    }
    return acc;
  }, []);

  return result;
};

export const reloadTableOfContents = async (methods) => {
  try {
    let tocUUID;
    const flowUUIDs = methods.get()[COMPLEX_DOCUMENT_CONTEXT_KEYS.FLOWS];
    let tocTitleBlockUUID =null;
    for (let uuid of flowUUIDs) {
      const flowName = methods.get()[uuid]?.flowName;
      if (flowName === TABLE_OF_CONTENTS) {
        const blockUUID = methods.get()[uuid]?.[`${uuid}-0`][0];
        tocUUID = uuid;
        tocTitleBlockUUID = blockUUID;
        break;
      }
    }
    
    if (!tocUUID) {
      throw new Error('Table of Contents flow not found');
    }

    const documentId = methods.get()[COMPLEX_DOCUMENT_CONTEXT_KEYS.ID];
    const response = await getTocFlow(documentId);
    
    if (response.statusCode === 3120 && response?.data) {
      response.data.blocks[0].uuid = tocTitleBlockUUID
      methods.replaceFlow(
        { flow: response.data, uuid: tocUUID, pageId: `${tocUUID}-0` },
        false
      );
    } else {
      console.error('Error refreshing Table of Contents', response);
    }
  } catch (err) {
    console.error('Error refreshing Table of Contents:', err);
  }
};

export const handleCommunNameCheck = async (name) => {
  const payload = {
    "communicationName": name
  }
  try {
    const res = await checkCommunName(JSON.stringify(payload));
    return res?.errors?.length ? res.errors : [];
  } catch (error) {
    console.error("Error during communication name check:", error);
    return [];
  }
};

export const isTocBlock = (blockUUId, store) => {
  if (!blockUUId) return false;

  const flows = store.get()?.[COMPLEX_DOCUMENT_CONTEXT_KEYS.FLOWS] || [];

  return flows.some(flowUUID => {
    const flow = store.get()?.[flowUUID];
    const flow_blockUUID = flow?.[`${flowUUID}-0`];

    return flow_blockUUID?.[0] === blockUUId && flow?.flowName === TABLE_OF_CONTENTS;
  });
};

export const updateFunnelChartData = (funnelChart = {}, totalEmail, t) => {
  const { sent = 0, delivered = 0, opened = 0, clicked = 0 } = funnelChart;

  if (totalEmail <= 0 || sent === 0) {
    return [
      { title: `${t(
        EMAIL_DASHBOARD.FUNNEL_SECTION_SENT_LABEL.key,
        EMAIL_DASHBOARD.FUNNEL_SECTION_SENT_LABEL.value,
      )}`, count: 0, percentage: 0 },
      { title: `${t(
        EMAIL_DASHBOARD.FUNNEL_SECTION_DELIVERED_LABEL.key,
        EMAIL_DASHBOARD.FUNNEL_SECTION_DELIVERED_LABEL.value,
      )}`, count: 0, percentage: 0 },
      { title: `${t(
        EMAIL_DASHBOARD.FUNNEL_SECTION_OPENS_LABEL.key,
        EMAIL_DASHBOARD.FUNNEL_SECTION_OPENS_LABEL.value,
      )}`, count: 0, percentage: 0 },
      { title: `${t(
        EMAIL_DASHBOARD.FUNNEL_SECTION_CLICKS_LABEL.key,
        EMAIL_DASHBOARD.FUNNEL_SECTION_CLICKS_LABEL.value,
      )}`, count: 0, percentage: 0 },
    ];
  }

  const formatCount = (val) =>{
    if (val >= 1000000) {
      // more than one million
      return (val / 1000000).toFixed(1) + 'M';
    } else if (val >= 1000) {
      // more than one thousands
      return (val / 1000).toFixed(1) + 'k';
    } else {
      return val;
    }
  }

  const funnelData =  [
    { title: emailFunnelChartLabels(t).sent, count: formatCount(sent), percentage: Math.round((sent / totalEmail) * 100) },
    { title: emailFunnelChartLabels(t).delivered, count: formatCount(delivered), percentage: Math.round((delivered / sent) * 100) },
    { title: emailFunnelChartLabels(t).opened, count: formatCount(opened), percentage: Math.round((opened / delivered) * 100) },
    { title: emailFunnelChartLabels(t).clicked, count: formatCount(clicked), percentage: opened ? Math.round((clicked / opened) * 100) : 0 },
  ];

  return funnelData.map(data => ({
    ...data,
    title: removeInvisibleCharacters(data.title),
  }));
};


export const getChannelUnknownCount = (data) => {
  const unknownCount = data.reduce(
    (acc, item) => {
      const count = Number(item.unknownCount || 0);
      acc[item.channel] = (acc[item.channel] || 0) + count;
      return acc;
    },
    { print: 0, email: 0 }
  );
  return unknownCount;
};

export const getBusinessLogicByType = (data = [], type, isIdName = false) => {
  if (!type) return [];
  if (isIdName) {
    const filtered = data.filter(item => item.type === type);
    return filtered.map((data) => ({ id: data.id, name: data.name }))
  } else {
    return data.filter(item => item.type === type);
  }
};

export const buildBusinessLogicMaps = (businessLogics, currentStore) => {
  const flowBusinessLogicMap = new Map();
  const elementBusinessLogicMap = new Map();

  const flowBusinessLogicData = getBusinessLogicByType(businessLogics, 'flow');
  const elementBusinessLogicData = getBusinessLogicByType(businessLogics, 'element');

  const flows = currentStore[COMPLEX_DOCUMENT_CONTEXT_KEYS.FLOWS];

  // 🔹 Helper: process a single block and update elementBusinessLogicMap
  const processBlockGroups = block => {
    if (block?.blockType !== CREATIVE_BLOCK || !block.groups?.length) return;

    block.groups.forEach(group => {
      const isBLPresent = elementBusinessLogicData.some(el =>
        el.rules[0]?.groupIDs?.includes(group.groupId),
      );

      elementBusinessLogicMap.set(group.groupId, {
        groupName: group.groupName,
        isBLPresent,
      });
    });
  };

  flows.forEach(flowUUID => {
    const flowId = currentStore[COMPLEX_DOCUMENT_CONTEXT_KEYS.PERSISTED_KEYS][flowUUID];
    const flow = currentStore[flowUUID];

    // 🔹 Flow level business logic map
    const hasBusinessLogic = flowBusinessLogicData.find(
      flowBL => flowBL.rules[0]?.flowId === flowId,
    );
    flowBusinessLogicMap.set(flowId, {blId: hasBusinessLogic?.id, isBLPresent: Boolean(hasBusinessLogic)});

    // 🔹 Process header/footer if present
    if (flow.header) processBlockGroups(currentStore[flow.header]);
    if (flow.footer) processBlockGroups(currentStore[flow.footer]);

    // 🔹 Process page blocks
    const blocks = flow[`${flowUUID}-0`] || [];
    if (blocks.length > 0)
      blocks.forEach(blockUUID => processBlockGroups(currentStore[blockUUID]));
  });
  return { flowBusinessLogicMap, elementBusinessLogicMap };
};
